import "./Contact.css";
import HomeContact from "../HomeContact";
import React, { useEffect, useRef } from 'react';
import emailjs from '@emailjs/browser';
import {useState} from "react";

const Contact = () => {
    const [isPending, setIsPending] = useState(false);
    const [isSent, setIsSent] =  useState(false);
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();
        setIsPending(true);
        emailjs.sendForm('service_7vqg2w6', 'template_gt8bitl', form.current, 'qBxC5a-aCtQ3zQXGZ')
        .then((result) => {
          console.log(result.text);
          e.target.reset();
          setIsSent(true);
          setIsPending(false);
        }, (error) => {
          console.log(error.text);
        });
    };

    //Message sent pop-up
    useEffect(() => {
        const toast = document.querySelector(".toast");

        if(isSent === true){
            toast.classList.add("off");
            setTimeout(()=> {
                setIsSent(false);
            }, 3000);
        } else{
            toast.classList.remove("off");
        }
    })

    return ( 
        <>
            <h1 className="heading">Leave Us A Message</h1>
            <div className="form">
                <form ref={form} onSubmit={sendEmail}>
                <div id="toasts">
                    <div className="toast">Message has been sent</div>
                </div>
                    <label>Name</label>
                    <input 
                        type="text"
                        placeholder="Enter your name"
                        required
                        name="user_name"
                    />
                    <label>Email Address</label>
                    <input 
                        type="email"
                        placeholder="Enter your email"
                        required
                        name="email_address" 
                    />
                    <label>Subject</label>
                    <input 
                        type="text"
                        placeholder="Enter a subject"
                        required
                        name="subject" 
                    />
                    <label>Message</label>
                    <textarea
                        required
                        name="message" 
                    ></textarea>
                    { !isPending && <button type="submit" value="Send" className="btn" >Send Message</button>}
                    { isPending && <button disabled className="btn">Sending Message...</button>}
                    
                </form>
            </div>
            <HomeContact />
        </>
     );

}
 
export default Contact;